/**
 * Werken bij: one carousel behaviour for the vakgebied, verhalen and
 * "zo kan een dag" sliders, plus the mobile vacancy slider on the landing page.
 *
 * Swiper 11 is loaded globally in layout/theme.liquid. Controls are resolved
 * inside each carousel root rather than by a document-wide selector, so two
 * sliders on the same page stay independent.
 *
 * Markup contract:
 *   <div data-vac-carousel
 *        data-slides-mobile="1" data-slides-tablet="2" data-slides-desktop="3"
 *        data-gap="24" data-loop="false">
 *     <div class="swiper"> <div class="swiper-wrapper"> ...slides... </div> </div>
 *     ...vacancy-carousel-controls...
 *   </div>
 */
(function () {
  'use strict';

  var ATTEMPT_DELAY = 100;
  var MAX_ATTEMPTS = 50;

  function intAttr(el, name, fallback) {
    var raw = parseInt(el.getAttribute(name), 10);
    return isNaN(raw) ? fallback : raw;
  }

  function syncNavState(root, swiper) {
    var prev = root.querySelector('.vac-carousel__prev');
    var next = root.querySelector('.vac-carousel__next');

    if (prev) {
      prev.setAttribute('aria-disabled', swiper.isBeginning && !swiper.params.loop ? 'true' : 'false');
    }
    if (next) {
      next.setAttribute('aria-disabled', swiper.isEnd && !swiper.params.loop ? 'true' : 'false');
    }
  }

  function init(root) {
    if (root.dataset.vacCarouselReady === 'true') return;

    var container = root.querySelector('.swiper');
    if (!container) return;

    var progress = root.querySelector('.vac-carousel__progress');
    var options = {
      slidesPerView: intAttr(root, 'data-slides-mobile', 1),
      spaceBetween: intAttr(root, 'data-gap', 24),
      loop: root.getAttribute('data-loop') === 'true',
      a11y: { enabled: true },
      keyboard: { enabled: true, onlyInViewport: true },
      navigation: {
        prevEl: root.querySelector('.vac-carousel__prev'),
        nextEl: root.querySelector('.vac-carousel__next')
      },
      breakpoints: {
        750: { slidesPerView: intAttr(root, 'data-slides-tablet', 2) },
        990: { slidesPerView: intAttr(root, 'data-slides-desktop', 3) }
      }
    };

    if (progress) {
      progress.classList.add('swiper-pagination');
      options.pagination = { el: progress, type: 'progressbar' };
    }

    var swiper = new window.Swiper(container, options);

    syncNavState(root, swiper);
    swiper.on('slideChange', function () {
      syncNavState(root, swiper);
    });
    swiper.on('breakpoint', function () {
      syncNavState(root, swiper);
    });

    root.dataset.vacCarouselReady = 'true';
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-vac-carousel]');
    for (var i = 0; i < roots.length; i++) {
      init(roots[i]);
    }
  }

  function start(attempt) {
    // Swiper comes from a CDN tag in the head; retry briefly if it is not there
    // yet, the same defensive pattern the existing form snippets use.
    if (window.Swiper) {
      initAll();
      return;
    }
    if (attempt >= MAX_ATTEMPTS) return;
    setTimeout(function () {
      start(attempt + 1);
    }, ATTEMPT_DELAY);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      start(0);
    });
  } else {
    start(0);
  }

  // The theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', function () {
    start(0);
  });
})();
